const Paragraph = ({content}:{content:React.ReactNode}) => {
  return (
    <p className="text-justify tracking-tight break-normal leading-relaxed content-text-size word-spacing-wide ">{content}</p>
  )
}

export default Paragraph